import { Config } from "src/app/config";
import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectList extends PageObject {
  style: string;
  color: string;
  font: string;
  fontSize: number;
  lineHeight: number;
  listType: string;
  listSpace: number;
  items: string[];
  private ignoreChange: boolean;

  constructor(obj: PageObjectList = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.List;
    this.ignoreChange = false;

    if (obj == null) {
      this.style = "text-normal";
      this.color = "#000";
      this.font = "arial";
      this.fontSize = 16;
      this.lineHeight = 24;
      this.listType = "upper-alpha";
      this.listSpace = 4;
      this.items = ["Option 1", "Option 2"];

      if (Config.STYLE[style]) {
        if (Config.STYLE[style][this.style]) {
          this.color = Config.STYLE[style][this.style].color;
          this.font = Config.STYLE[style][this.style].font;
          this.fontSize = Config.STYLE[style][this.style].fontSize;
          this.lineHeight = Config.STYLE[style][this.style].lineHeight;
        }
      }
    } else {
      this.style = obj.style || "";
      this.color = obj.color;
      this.font = obj.font;
      this.fontSize = obj.fontSize;
      this.lineHeight = obj.lineHeight;
      this.items = [...obj.items];
      this.listType = obj.listType;
      this.listSpace = obj.listSpace;
      if (Config.STYLE[style]) {
        if (Config.STYLE[style][this.style]) {
          this.color = Config.STYLE[style][this.style].color;
          this.font = Config.STYLE[style][this.style].font;
          this.fontSize = Config.STYLE[style][this.style].fontSize;
          this.lineHeight = Config.STYLE[style][this.style].lineHeight;
        }
      }
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    let style = new ObjectProperty("Style", OBJECTPROPERTYTYPE.List);
    style.addOption("text-normal", "Normal");
    style.addOption("text-normal-sm", "Normal Small");
    style.addOption("text-normal-lg", "Normal Large");
    style.addOption("", "Custom");
    list.push(style);

    if (this.style == "") {
      list.push(new ObjectProperty("Color", OBJECTPROPERTYTYPE.Text));
      list.push(new ObjectProperty("Font", OBJECTPROPERTYTYPE.Text));
      list.push(new ObjectProperty("Font Size", OBJECTPROPERTYTYPE.Text));
      list.push(new ObjectProperty("Line Height", OBJECTPROPERTYTYPE.Text));
    }

    let listType = new ObjectProperty("List Type", OBJECTPROPERTYTYPE.List);
    listType.addOption("none", "None");
    listType.addOption("disc", "Disc");
    listType.addOption("circle", "Circle");
    listType.addOption("square", "Square");
    listType.addOption("decimal", "Decimal");
    listType.addOption("lower-alpha", "Lower Alpha");
    listType.addOption("upper-alpha", "Upper Alpha");
    listType.addOption("upper-roman", "Roman");
    list.push(listType);

    let listSpace = new ObjectProperty("List Space", OBJECTPROPERTYTYPE.List);
    listSpace.addOption("0", "None");
    listSpace.addOption("4", "Small");
    listSpace.addOption("8", "Medium");
    listSpace.addOption("16", "Large");
    list.push(listSpace);

    for (let i = 0; i < this.items.length; i++) {
      list.push(new ObjectProperty("Item " + (i + 1), OBJECTPROPERTYTYPE.TextLong));
    }
    list.push(new ObjectProperty("New Item", OBJECTPROPERTYTYPE.TextLong));

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Style") {
      return this.style;
    } else if (name == "Color") {
      return this.color;
    } else if (name == "Font") {
      return this.font;
    } else if (name == "Font Size") {
      return this.fontSize;
    } else if (name == "Line Height") {
      return this.lineHeight;
    } else if (name.indexOf("Item") == 0) {
      let s = name.split(" ");
      let i = +s[1] - 1;
      return this.items[i];
    } else if (name == "New Item") {
      return "";
    } else if (name == "List Type") {
      return this.listType;
    } else if (name == "List Space") {
      return this.listSpace + "";
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    // Skip the problem with OBJECTPROPERTYTYPE.Text with blur and enter event
    if (this.ignoreChange) {
      return;
    }
    this.ignoreChange = true;
    setTimeout(() => (this.ignoreChange = false), 100);
    // <<-- End

    super.setPropertyValue(name, value, style);

    if (name == "Style") {
      this.style = value;
      if (Config.STYLE[style]) {
        if (Config.STYLE[style][this.style]) {
          this.color = Config.STYLE[style][this.style].color;
          this.font = Config.STYLE[style][this.style].font;
          this.fontSize = Config.STYLE[style][this.style].fontSize;
          this.lineHeight = Config.STYLE[style][this.style].lineHeight;
        }
      }
    } else if (name == "Color") {
      this.color = value;
    } else if (name == "Font") {
      this.font = value;
    } else if (name == "Font Size") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.fontSize = newValue;
      }
    } else if (name == "Line Height") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.lineHeight = newValue;
      }
    } else if (name.indexOf("Item") == 0) {
      let s = name.split(" ");
      let i = +s[1] - 1;
      if (value == "") {
        this.items.splice(i, 1);
      } else {
        this.items[i] = value;
      }
    } else if (name == "New Item") {
      this.items.push(value);
    } else if (name == "List Type") {
      this.listType = value;
    } else if (name == "List Space") {
      this.listSpace = +value;
    }
  }
}
